import { s as shouldUpdateFacetSearchComponent } from './facet-values-group-e87e165b.js';

function announceFacetSearchResultsWithAriaLive(facet, label, setAriaLive, i18n) {
  let prevState = facet.state.facetSearch;
  facet.subscribe(() => {
    if (shouldUpdateFacetSearchComponent(facet.state.facetSearch, prevState) &&
      facet.state.facetSearch.query) {
      prevState = facet.state.facetSearch;
      setAriaLive(i18n.t('facet-search-results-count', {
        count: facet.state.facetSearch.values.length,
        label,
      }));
    }
  });
}

export { announceFacetSearchResultsWithAriaLive as a };

//# sourceMappingURL=facet-search-aria-live-9eaa1aa1.js.map